import { useState, useEffect } from "react";
import MasterTopButtons from "../../../components/MasterTopButtons/MasterTopButtons";
import ExcelExport from "../../../components/ExcelExport/ExcelExport";
import "../../SalesMasterPages/LeadList/LeadList.css";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import SearchIcon from "@mui/icons-material/Search";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Loader from '../../../components/Loader/loader';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { DateRangePicker } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { blue } from "@mui/material/colors";
import CryptoJS from 'crypto-js';
import ReactTooltip from 'react-tooltip';
import { FaFilter } from "react-icons/fa";
import { FcClearFilters } from "react-icons/fc";
import { eachDayOfInterval, startOfMonth, endOfMonth } from "date-fns";


const start = startOfMonth(new Date(2025, 1, 1)); // Feb 1, 2025
const end = endOfMonth(new Date(2025, 1, 1)); // Feb 28, 2025

const allDays = eachDayOfInterval({ start, end });

const LeadList = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);
  const weekStartsOn = 0;
  const [dateRange, setDateRange] = useState('Custom Dates');
  const togglePicker = () => {
    setDateRange(formatDate(selectionRange.startDate) + ' - ' + formatDate(selectionRange.endDate))
    setIsOpen(!isOpen);
  };
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // State for the Navigation list
  const [assignToResponse, setAssignToResponse] = useState([]);

  const [assignedto, setAssignedto] = useState("0");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [myORallleads, setMyORallleads] = useState("0");
  const [isAvailable, setIsAvailable] = useState(false);

  const [availableClass, setAvailableClass] = useState("unavailable");

  const [totalPages, setTotalPages] = useState();
  const [totalRecords, setTotalRecords] = useState(0);

  const [pageSize, setPageSize] = useState(50);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [filterdata, setFilterdata] = useState('');
  const [statusColor, setStatusColor] = useState("#28A745");
  const [leadtype, setLeadtype] = useState("");
  const [leadSource, setLeadSource] = useState("0");
  const [serviceType, setServiceType] = useState("0");
  const [serviceTypeResponse, setServiceTypeResponse] = useState([]);
  const isAdmin = localStorage.getItem("isAdmin");

  const [leads, setLeads] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Lead";
  const heading = "Lead List";
  const [leadLabelResponse, setLeadLabelResponse] = useState([]);
  const [leadLabel, setLeadLabel] = useState("0");

  function getStatusColor(statusName) {
    switch (statusName) {
      case 'Untouched':
        return 'orange';
      case 'Open':
        return '#28A745';
      case 'Closed':
        return '#DC3545';
      case 'Converted':
        return '#87CEEB';
      default:
        return 'white';
    }
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
    return encodeURIComponent(ciphertext);
  }



  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }
  const handleSelect = (ranges) => {
    // ranges contains an object with startDate and endDate
    setSelectionRange(ranges.selection);
  };


  useEffect(() => {
    getServiceType();
    getEmployeeByDepartment();
    getLeadLabel();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    let opt = 10;
    if (filterdata) {
      opt = filterdata;
    }

    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = '';
      enddate = '';
    }


    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetLeadListNew?pageNumber=${currentPage}&pageSize=${pageSize}&option=${opt}&searchParam=${searchKeyword}&emailSearch=${assignedto}&leadSource=${leadSource}&lead_region=${leadtype}&startDate=${startdate}&endDate=${enddate}&serviceType=${serviceType}&myOrAll=${myORallleads}&leadLabel=${leadLabel}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUserDetailResponse(response.data.data);
            setTotalPages(response.data.totalPages);
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });

      axios
        .get(`${baseAPI}userget/GetAvailibility`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setIsAvailable(response.data.data[0].is_available);
          {
            response.data.data[0].is_available
              ? setAvailableClass("available")
              : setAvailableClass("unavailable");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, [currentPage]);


  const redirectToAddLead = () => {
    // Redirect to another page
    navigate('/AddLead');
  };


  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }


  function getLeadListButton() {

    if (isOpen) {
      setDateRange(formatDate(selectionRange.startDate) + ' - ' + formatDate(selectionRange.endDate));
      setIsOpen(!isOpen);
    }
    setCurrentPage(1);
    if (!filterdata) {
      setFilterdata('10', () => {
        getLeadList('10'); // Ensure getLeadList is called after state update
      });
    } else {
      getLeadList(filterdata);
    }
  }

  function clearFilter() {
    setCurrentPage(1);
    setDateRange("Custom Dates");
    setSearchKeyword("");
    setAssignedto('0');
    setLeadSource('0');
    setLeadtype("");
    setFilterdata('10');
    getLeadList('10');
    setServiceType("0");
    setMyORallleads("0");
  }

  const clearDateRange = () => {
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
  };



  function getLeadList(filterdata) {
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = '';
      enddate = '';
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetLeadListNew?pageNumber=${currentPage}&pageSize=${pageSize}&option=${filterdata}&searchParam=${searchKeyword}&emailSearch=${assignedto}&leadSource=${leadSource}&lead_region=${leadtype}&startDate=${startdate}&endDate=${enddate}&serviceType=${serviceType}&myOrAll=${myORallleads}&leadLabel=${leadLabel}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setUserDetailResponse(response.data.data);
            setTotalPages(response.data.totalPages);
            setTotalRecords(response.data.totalRecords);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
  }

  function getServiceType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GetServiceType`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setServiceTypeResponse(response.data.data);

      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleChange = (e) => {
    setFilterdata(e.target.value);
    // getLeadList(e.target.value);

  };


  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handlemyOrAllLead = (e) => {
    setMyORallleads(e.target.value);
  };


  const handleAssignChange = (e) => {
    setAssignedto(e.target.value);
  };
  const handleLeadTypeChange = (e) => {
    setLeadtype(e.target.value);
  };
  const handleLeadSourceChange = (e) => {
    setLeadSource(e.target.value);
  };
  const handleServiceTypeChange = (e) => {
    setServiceType(e.target.value);
  };

  const handleLeadLabel = (e) => {
    setLeadLabel(e.target.value);
  };



  async function handleAvailability() {
    try {
      let available;

      if (isAvailable) {
        available = 0;
        setAvailableClass("unavailable");
      } else {
        available = 1;
        setAvailableClass("available");
      }
      setIsAvailable(!isAvailable);
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/SetAvailability`,
        {
          is_availibility: available,
        }, // Send request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Handle the response here (e.g., show a success message)

    } catch (error) {
      console.error("Error posting data:", error);
    }
  }

  function nextPage(Relocation_ID) {

    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/viewleaddetails?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, '_blank');
  }

  function nextPage1(Relocation_ID) {

    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/viewleaddetail?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, '_blank');
  }




  //pagination


  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  //const visibleData = userDetailResponse?.slice(startIndex, endIndex);

  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage);
  // };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // const handlePageSizeChange = (newPageSize) => {
  //   // if (newPageSize >= 1 && newPageSize <= totalPages) {
  //   //   setPageSize(newPageSize);
  //   // }

  // };

  async function deleteLead(relocationId) {
    const isConfirmed = window.confirm("Are you sure you want to delete this record?");
    if (isConfirmed) {

      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}userpost/DeleteRelocationId`,
        {
          data: { relocation_id: relocationId }, // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getLeadListButton();
    };
  }

  function getLeadLabel() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GetLeadLabel?label_id=0`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {

        setLeadLabelResponse(response.data.data);

      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }



  return (
    <>

      <div className="app-container-LeadList">
        <MiniDrawer />
        <div className="container-fluid container-LeadList">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "1rem", lineHeight: "1.7" }}>
                Lead List| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Lead List</span>
              </h1>

            </div>
            <div className="lead-list-button">
              <div className="unavalablel-Leadlist"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >


                <button onClick={handleAvailability} className={availableClass}>
                  {isAvailable ? "Available" : "Unavailable"}
                </button>
              </div>

              <div>
                <p className="icon total-records-icon" style={{

                  borderColor: "#C0C6CC",
                  border: "1px solid",
                  textAlign: "center",
                  padding: "10px",
                  fontSize: "13px",
                  // width: "11rem",
                  height: "2.5rem",
                  borderRadius: "0.5rem",

                }}> <b> Total Records: </b> <span style={{ color: "#5B489D" }}><b>{totalRecords}</b></span></p>
              </div>
              {/* <div>
              <ExcelExport userDetailResponse={userDetailResponse} />
              </div> */}

            </div>

          </div>
          <wrapper className="wrapper leadList">
            <div className="content-container-LeadList">
              <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                <div style={{ display: "flex", overflowX: "auto" }}>
                  <div className=" headerButton" style={{ display: "flex", gap: "10px", justifyContent: "left" }}>
                    <div>
                      <select
                        style={{
                          marginBottom: "1rem",
                          width: "11rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold"
                        }}
                        name="myORallleads"
                        value={myORallleads}
                        onChange={handlemyOrAllLead}
                      >
                        <option value="0">My Leads</option>
                        <option value="1">All Leads</option>
                      </select>
                    </div>


                    <div>
                      <input
                        style={{
                          marginBottom: "1rem",
                          width: "11rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",

                        }}
                        type="text"
                        name="searchKeyword"
                        value={searchKeyword}
                        onChange={handleSearchChange}
                        placeholder="Search"
                      />

                    </div>
                    <div>
                      <select
                        style={{
                          marginBottom: "1rem",
                          width: "11rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold"
                        }}
                        name="filterdata"
                        value={filterdata}
                        onChange={handleChange}
                      >
                        <option value="10">Today's Task</option>
                        <option value="4">Today's Leads</option>
                        <option value="5">Today's Followup</option>
                        <option value="7">Tomorrow's Followup</option>
                        <option value="8">Missed Followup</option>
                        <option value="6">Today's Update</option>
                        <option value="9">Total Leads</option>
                        <option value="1">Total Untouched Lead</option>
                        <option value="2">Total Open Leads</option>
                        <option value="3">Total Close Leads</option>
                        <option value="11">Missed IVR</option>
                        <option value="12">Answered IVR</option>
                        <option value="13">Converted</option>

                        {/*<option value="7">Converted Ratio</option> */}



                      </select>
                    </div>
                    <div>
                      <select
                        name="leadSource"
                        onChange={handleLeadSourceChange}
                        value={leadSource}
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold"
                        }}
                      >
                        <option disabled value="0">Lead Source</option>
                        <option value="1">Web Query</option>
                        <option value="2">Email</option>
                        <option value="3">IVR</option>
                        <option value="4">Others</option>
                        <option value="5">IPATA</option>
                        <option value="6">Campaign</option>
                        <option value="99">All</option>
                      </select>
                    </div>
                    <div>
                      <select
                        name="leadtype"
                        onChange={handleLeadTypeChange}
                        value={leadtype}
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold"
                        }}
                      >
                        <option disabled value="">Lead Type</option>
                        <option value="0">All</option>
                        <option value="Domestic">Domestic</option>
                        <option value="International">International</option>
                      </select>
                    </div>
                    <div>
                      <select
                        name="serviceType"
                        value={serviceType}
                        onChange={handleServiceTypeChange}
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                      >
                        <option value="0">Service Type</option>
                        {serviceTypeResponse !== null ? (
                          serviceTypeResponse.map((item) => (
                            <option value={item.service_type}>
                              {item.ServiceTypeName}
                            </option>
                          ))
                        ) : (
                          <p>empty</p>
                        )}
                      </select>
                    </div>
                    <div>
                      <select
                        name="leadLabel"
                        value={leadLabel}
                        onChange={handleLeadLabel}
                        style={{
                          marginBottom: "1rem",
                          width: "7rem",
                          height: "2.5rem",
                          borderRadius: "0.5rem",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                      >
                        <option value="0">Lead Label</option>
                        {leadLabelResponse !== null &&
                          leadLabelResponse !== undefined &&
                          leadLabelResponse.length > 0 ? (
                          leadLabelResponse.map((item) => (
                            <option value={item.label_id}>
                              {item.label_name} {"(" + item.label_color + ")"}{" "}
                            </option>
                          ))
                        ) : (
                          <option value="-1">NA</option>
                        )}
                      </select>
                    </div>


                    {isAdmin === "true" && (
                      <div>
                        <select
                          name="assignedto"
                          onChange={handleAssignChange}
                          value={assignedto}
                          style={{
                            marginBottom: "1rem",
                            width: "7rem",
                            height: "2.5rem",
                            borderRadius: "0.5rem",
                            fontSize: "13px",
                            fontWeight: "bold"
                          }}
                        >
                          <option disabled value="0">Assigned To</option>
                          {assignToResponse.map((item) => (
                            <option value={item.customer_id} className={item.is_available ? 'green' : 'black'}>
                              {item.name}
                            </option>
                          ))}
                          <option value="All">All</option>
                        </select>
                      </div>)}

                    <div>
                      <button style={{
                        marginBottom: "1rem",
                        width: "12rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        fontSize: "13px",

                      }} onClick={togglePicker}> <b> {dateRange}</b></button>
                      {isOpen && (
                        <div style={{ position: 'absolute', zIndex: 999, border: "solid 1px black", marginLeft: "-13pc", width: "35pc", background: "white" }}>
                          <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                          />
                          <button onClick={clearDateRange} style={{
                            marginBottom: "1rem",
                            width: "5rem",
                            height: "2.5rem",
                            borderRadius: "0.5rem",
                            fontSize: "13px",
                            position: "relative",
                            top: "1px",
                            left: "22pc",
                            color: "red",
                            border: "none"


                          }}>Reset</button>
                          <button style={{
                            marginBottom: "1rem",
                            width: "7rem",
                            height: "2.5rem",
                            borderRadius: "0.5rem",
                            fontSize: "13px",
                            position: "relative",
                            top: "1px",
                            left: "22pc",
                            backgroundColor: "#5B489D",
                            color: "White"

                          }} onClick={togglePicker}>Done</button>
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="fafilterApply" style={{ position: 'relative', display: 'inline-block' }}>
                        <div className="Leadlist-filter"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >


                          <button onClick={getLeadListButton} className="">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="fafilterresetApply" style={{ position: 'relative', display: 'inline-block' }}>

                        <div className="Leadlist-filter-clear"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >


                          <button onClick={clearFilter} className="">
                            Clear Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </wrapper>
          <br />
          <div>
            <div className="sscroll">
              <Wrapper className="leadList">
                <div className="content-container-LeadList">

                  {loading ? (
                    <Loader /> // Display the loader while data is being fetched
                  ) : (
                    <div className="container-fluid">
                      <div className="leadList">
                        <table style={{ width: "100%" }}>
                          <tr className="leadListHeading">
                            <th style={{ width: "4%" }}>#</th>
                            <th style={{ width: "20%" }}>Created Time</th>
                            <th style={{ width: "18%" }}>Lead Details</th>
                            <th style={{ width: "18%" }}>ID</th>
                            <th style={{ width: "25%" }}>Follow-up Remarks</th>
                            <th style={{ width: "5%" }}>Details</th>
                            <th style={{ width: "4%" }}>Delete</th>
                          </tr>
                          {userDetailResponse?.length > 0 ? (
                            userDetailResponse.map((user, index) => (
                              <tr>

                                <td style={{ verticalAlign: 'baseline' }}>
                                  <div>
                                    <div class="triangle" style={{ borderTopColor: user.label_color, }} title={user.label_name}    ></div>
                                    <div class="row-number">
                                      {++index}
                                    </div>
                                  </div>

                                </td>


                                <td>
                                  <table className="leadlist_1">
                                    <tr>
                                      <td
                                        style={{
                                          width: "40%",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Entry Date
                                      </td>
                                      <td style={{ width: "4%" }}>:</td>
                                      <td style={{ width: "55%" }}>
                                        {user.createdDate}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Last Update
                                      </td>
                                      <td>:</td>
                                      <td>{user.modified_date}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Total Follow Up
                                      </td>
                                      <td>:</td>
                                      <td>{user.total_followups}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Follow-up Date & Time
                                      </td>
                                      <td>:</td>
                                      <td>{user.last_followup_date}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Next Followup Date & Time
                                      </td>
                                      <td>:</td>
                                      <td>{user.next_follow_up}</td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="leadlist_1">
                                    <tr>
                                      <td
                                        style={{
                                          width: "40%",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Name
                                      </td>
                                      <td style={{ width: "4%" }}>:</td>
                                      <td style={{ width: "55%" }}>
                                        {user.First_Name} {user.Last_Name}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Phone
                                      </td>
                                      <td>:</td>
                                      <td>{user.Mobile_No}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Alternate Phone
                                      </td>
                                      <td>:</td>
                                      <td>{user.alternate_number}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Email
                                      </td>
                                      <td>:</td>
                                      <td>{user.Email}</td>
                                    </tr>
                                    <tr>
                                      {/* <td style={{ fontWeight: "bold" }}>
                                      Lead Type
                                    </td>
                                    <td>:</td>
                                    <td>{user.lead_region}</td> */}
                                      <td style={{ fontWeight: "bold" }}>
                                        Origin
                                      </td>
                                      <td>:</td>
                                      <td>
                                        {user.Origin_City1},{user.Origin_State1}
                                        ,{user.Origin_Country1}
                                      </td>
                                    </tr>
                                    <tr>
                                      {/* <td style={{ fontWeight: "bold" }}>
                                      Service Type
                                    </td>
                                    <td>:</td>
                                    <td>{user.ServiceTypeName}</td> */}
                                      <td style={{ fontWeight: "bold" }}>
                                        Destination
                                      </td>
                                      <td>:</td>
                                      <td>
                                        {user.Destination_City1},
                                        {user.Destination_State1},
                                        {user.Destination_Country1}
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                                <td>
                                  <table className="leadlist_1">
                                    {/* <tr>
                                    <td
                                      style={{ width: "40%", fontWeight: "bold" }}
                                    >
                                      Sr No.
                                    </td>
                                    <td style={{ width: "4%" }}>:</td>
                                    <td style={{ width: "55%" }}>{++index}</td>
                                  </tr> */}
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Lead Type
                                      </td>
                                      <td>:</td>
                                      <td>{user.lead_region}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Service Type
                                      </td>
                                      <td>:</td>
                                      <td>{user.ServiceTypeName}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Lead ID
                                      </td>
                                      <td>:</td>
                                      <td>{user.Relocation_ID}</td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Lead Source
                                      </td>
                                      <td>:</td>
                                      <td>
                                        {user.LeadSource1}{" "}
                                        {user.call_status ? (
                                          <span>({user.call_status})</span>
                                        ) : (
                                          <span></span>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Status
                                      </td>
                                      <td>:</td>
                                      <td>
                                        <b
                                          style={{
                                            height: "30px",
                                            width: "100px",
                                            color: "white",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            padding: "6px",
                                            borderRadius: "15px",
                                            backgroundColor: getStatusColor(
                                              user.status_name
                                            ),
                                          }}
                                        >
                                          {" "}
                                          {user.status_name}{" "}
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ fontWeight: "bold" }}>
                                        Assigned
                                      </td>
                                      <td>:</td>
                                      <td>{user.Assigned_To}</td>
                                    </tr>
                                  </table>
                                </td>
                                <td>{user.last_followup_remark}</td>
                                <td>
                                  <button
                                    onClick={() =>
                                      nextPage1(user.Relocation_ID)
                                    }
                                    style={{
                                      height: "30px",
                                      width: "38px",
                                      backgroundColor: "#5B489D",
                                    }}
                                  >
                                    <SearchIcon
                                      className="icon"
                                      style={{ color: "white" }}
                                    />
                                  </button>
                                </td>
                                <td>
                                  {isAdmin === "true" && (
                                    <button
                                      onClick={() =>
                                        deleteLead(user.Relocation_ID)
                                      }
                                      style={{
                                        height: "36px",
                                        width: "44px",
                                        // backgroundColor: "#5B489D"
                                      }}
                                    >
                                      <MdDelete
                                        className="icon"
                                        style={{
                                          color: "red",
                                          height: "32px",
                                          width: "29px",
                                        }}
                                      />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <p>empty</p>
                          )}
                        </table>
                        <nav
                          aria-label="Page navigation"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "1rem",
                          }}
                        >
                          <ul className="pagination">
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage - 1);
                                }}
                                disabled={currentPage === 1}
                              >
                                Previous
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage - 1);
                                }}
                                disabled={currentPage === 1}
                              >
                                {currentPage - 1}
                              </a>
                            </li>
                            <li className="page-item active">
                              <a className="page-link">{currentPage}</a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage + 1);
                                }}
                                disabled={
                                  endIndex >= userDetailResponse?.length
                                }
                              >
                                {currentPage + 1}
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                style={{ cursor: "pointer" }}
                                className="page-link"
                                onClick={() => {
                                  handlePageChange(currentPage + 1);
                                }}
                                disabled={
                                  endIndex >= userDetailResponse?.length
                                }
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )}
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadList;
